import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import classNames from 'classnames/bind'
import React, { useCallback } from "react"
import { useThemes } from "../../../utils/themes"
import styles from "./ThemeSwitcher.module.scss"
const cx = classNames.bind(styles)

const ThemeSwitcher = () => {
    const { theme, toggleTheme } = useThemes()
    const onChange = useCallback(() => {
        toggleTheme(theme === 'dark' ? 'light' : 'dark')
    }, [theme, toggleTheme])

    return <div className={cx('container', { 'on': theme === 'dark' })} onClick={onChange}>
        <div className={cx('icon')}>
            <FontAwesomeIcon className='fa-sm' icon={['fas', theme === 'dark' ? 'moon' : 'brightness']} />
        </div>
    </div>
}

export default ThemeSwitcher